var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLight4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    rx: 10,
    fill: "#EAFCFC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1280_130602)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.7841 48.1846H40.9755V44.3398C37.1349 45.6061 33.007 45.5984 29.2568 44.415V48.1846H26.206C24.9083 48.1846 24.2513 49.7542 25.163 50.6787L33.9316 59.5654C34.5036 60.1456 35.44 60.146 36.0146 59.5674L44.8241 50.6807C45.7394 49.759 45.0841 48.1846 43.7841 48.1846Z",
    fill: "#009999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0254 13.1582C14.7773 14.2002 10 19.6445 10 26.1826C10 32.7217 14.7773 38.1641 21.0244 39.2061C14.1722 31.858 14.1765 20.5026 21.0254 13.1582Z",
    fill: "#009999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9746 13.1582C55.8145 20.4929 55.8375 31.8477 48.9756 39.2061C55.2227 38.1641 60 32.7217 60 26.1826C60 19.6445 55.2227 14.2002 48.9746 13.1582Z",
    fill: "#009999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0002 10C26.077 10 18.8174 17.2596 18.8174 26.1828C18.8174 35.1061 26.077 42.3656 35.0002 42.3656C43.9234 42.3656 51.183 35.1061 51.183 26.1828C51.183 17.2596 43.9234 10 35.0002 10ZM33.8226 23.9839L37.4646 25.7646C38.6711 26.3546 39.4508 27.6037 39.4508 28.9468C39.4508 30.691 38.1832 32.1437 36.5211 32.4349V33.5192C36.5211 34.3282 35.8652 34.9841 35.0563 34.9841C34.2473 34.9841 33.5914 34.3282 33.5914 33.5192V32.489H32.024C31.215 32.489 30.5592 31.8331 30.5592 31.0241C30.5592 30.2151 31.215 29.5593 32.024 29.5593H35.9086C36.5553 29.5593 36.7584 28.6804 36.1777 28.3965L32.5357 26.6157C29.4953 25.1291 30.051 20.4482 33.4792 19.8478V18.8611C33.4792 18.0521 34.1351 17.3963 34.944 17.3963C35.753 17.3963 36.4089 18.0521 36.4089 18.8611V19.7937H37.986C38.795 19.7937 39.4509 20.4496 39.4509 21.2586C39.4509 22.0676 38.795 22.7234 37.986 22.7234H34.0917C33.4075 22.7234 33.2597 23.7086 33.8226 23.9839Z",
    fill: "#009999"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1280_130602"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLight4);
export default __webpack_public_path__ + "static/media/Icon-light-4.e13daacde8209275612a9b95bcd1b8a7.svg";
export { ForwardRef as ReactComponent };